import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_API = process.env.REACT_APP_API_IMAGE_URL;
const USER_MEET_API = process.env.REACT_APP_API_USER_MEET_URL;

if (!API_BASE_URL) {
    throw new Error("Missing REACT_APP_API_BASE_URL. Check your .env and restart the dev server.");
}

if (!USER_MEET_API) {
    throw new Error("Missing REACT_APP_API_USER_MEET_URL. Check your .env and restart the dev server.");
}

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        // If your backend expects Bearer, change to: `Bearer ${token}`
        config.headers.Authorization = `${token}`;
    }

    config.headers.userType = "User";

    if (config.useImageApi) {
        config.baseURL = IMAGE_API;
        config.headers["Content-Type"] = "multipart/form-data";
    }

    // ✅ NEW: Use UserMeet API base URL for meet endpoints
    if (config.useUserMeetApi) {
        config.baseURL = USER_MEET_API;
    }

    return config;
});

export default axiosInstance;